import React from "react";
import DirectoryCardData from "./DirectoryCardData";

const DirectoryCard = ({ data }) => {
  return (
    <div className="py-6">
      <div className="lg:grid xl:grid-cols-3 grid-cols-3 gap-6">
        {data.map((val) => {
          return <DirectoryCardData requestdata={val} key={val.employee_id} />;
        })}
      </div>
    </div>
  );
};

export default DirectoryCard;
